var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "gray-area", attrs: { id: "content" } }, [
    _c("div", { staticClass: "container" }, [
      _c(
        "div",
        { staticClass: "row" },
        [
          _c("sdr-breadcrumbs", {
            attrs: { active_item: "seventh", module: _vm.modulo },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "container shortcode travel-ideas" }, [
          _c(
            "h1",
            {
              staticClass: "idea-title",
              staticStyle: { "margin-bottom": "20px" },
            },
            [
              _vm._m(0),
              _vm._v(_vm._s(_vm.bookingconfirmation[_vm.getCurrentLocale])),
            ]
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-sm-8 col-md-9", attrs: { id: "main" } }, [
          _vm.modulo === "booking"
            ? _c("div", { staticClass: "booking-information sdr-box" }, [
                _c("h2", [
                  _vm._v(
                    _vm._s(_vm.pleaseselectconfirmation[_vm.getCurrentLocale]) +
                      " " +
                      _vm._s(_vm.getBookingProcessBookingResults.bookingCode) +
                      ", " +
                      _vm._s(
                        _vm.pleaseselectconfirmation2[_vm.getCurrentLocale]
                      ) +
                      " " +
                      _vm._s(_vm.getBookingProcessBookingResults.idInvoice)
                  ),
                ]),
                _vm._v(" "),
                _c("hr"),
                _vm._v(" "),
                _c("div", { staticClass: "booking-confirmation clearfix" }, [
                  _c("i", { staticClass: "soap-icon-recommend icon circle" }),
                  _vm._v(" "),
                  _c("div", { staticClass: "message" }, [
                    _c("h4", { staticClass: "main-message" }, [
                      _vm._v(_vm._s(_vm.thankyou[_vm.getCurrentLocale])),
                    ]),
                    _vm._v(" "),
                    _c("p", [
                      _vm._v(_vm._s(_vm.emailhassent[_vm.getCurrentLocale])),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c("hr"),
                _vm._v(" "),
                _c("h2", [
                  _vm._v(_vm._s(_vm.payment[_vm.getCurrentLocale]) + ":"),
                ]),
                _vm._v(" "),
                _c("dl", { staticClass: "term-description" }, [
                  _c("dt", [
                    _vm._v(
                      _vm._s(_vm.payment_firstname[_vm.getCurrentLocale]) + ":"
                    ),
                  ]),
                  _c("dd", [
                    _vm._v(
                      _vm._s(
                        _vm.getBookingProcessBookingObject.customer.firstName
                      )
                    ),
                  ]),
                  _vm._v(" "),
                  _c("dt", [
                    _vm._v(
                      _vm._s(_vm.payment_lastname[_vm.getCurrentLocale]) + ":"
                    ),
                  ]),
                  _c("dd", [
                    _vm._v(
                      _vm._s(
                        _vm.getBookingProcessBookingObject.customer.lastName
                      )
                    ),
                  ]),
                  _vm._v(" "),
                  _c("dt", [
                    _vm._v(
                      _vm._s(_vm.payment_email[_vm.getCurrentLocale]) + ":"
                    ),
                  ]),
                  _c("dd", [
                    _vm._v(
                      _vm._s(_vm.getBookingProcessBookingObject.customer.email)
                    ),
                  ]),
                  _vm._v(" "),
                  _c("dt", [
                    _vm._v(
                      _vm._s(_vm.payment_phone[_vm.getCurrentLocale]) + ":"
                    ),
                  ]),
                  _c("dd", [
                    _vm._v(
                      _vm._s(_vm.getBookingProcessBookingObject.customer.phone)
                    ),
                  ]),
                  _vm._v(" "),
                  _c("dt", [
                    _vm._v(
                      _vm._s(_vm.payment_address[_vm.getCurrentLocale]) + ":"
                    ),
                  ]),
                  _c("dd", [
                    _vm._v(
                      _vm._s(
                        _vm.getBookingProcessBookingObject.customer.address
                      )
                    ),
                  ]),
                  _vm._v(" "),
                  _c("dt", [
                    _vm._v(
                      _vm._s(_vm.payment_zipcode[_vm.getCurrentLocale]) + ":"
                    ),
                  ]),
                  _c("dd", [
                    _vm._v(
                      _vm._s(
                        _vm.getBookingProcessBookingObject.customer.zipCode
                      )
                    ),
                  ]),
                  _vm._v(" "),
                  _c("dt", [
                    _vm._v(
                      _vm._s(_vm.payment_city[_vm.getCurrentLocale]) + ":"
                    ),
                  ]),
                  _c("dd", [
                    _vm._v(
                      _vm._s(_vm.getBookingProcessBookingObject.customer.city)
                    ),
                  ]),
                  _vm._v(" "),
                  _c("dt", [
                    _vm._v(
                      _vm._s(_vm.payment_countrycode[_vm.getCurrentLocale]) +
                        ":"
                    ),
                  ]),
                  _c("dd", [
                    _vm._v(
                      _vm._s(
                        _vm.getBookingProcessBookingObject.customer.countryCode
                      )
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("hr"),
                _vm._v(" "),
                _c("h2", [
                  _vm._v(_vm._s(_vm.paymentmethod[_vm.getCurrentLocale]) + ":"),
                ]),
                _vm._v(" "),
                _c("p", [
                  _vm._v(_vm._s(_vm.forsecurity[_vm.getCurrentLocale])),
                ]),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _vm.getBookingProcessBookingObject.payment.type !== "OO"
                  ? _c("p", { staticClass: "red-color" }, [
                      _vm._v(
                        "\n                        " +
                          _vm._s(_vm.paymentismadeby[_vm.getCurrentLocale]) +
                          "\n                        " +
                          _vm._s(
                            _vm.getBookingProcessBookingObject.payment
                              .ccPayment !== null
                              ? _vm.creditcard[_vm.getCurrentLocale]
                              : null
                          ) +
                          "\n                        " +
                          _vm._s(
                            _vm.getBookingProcessBookingObject.payment
                              .ddPayment !== null
                              ? _vm.debit[_vm.getCurrentLocale]
                              : null
                          ) +
                          "\n                        " +
                          _vm._s(
                            _vm.getBookingProcessBookingObject.payment.type ===
                              "CS"
                              ? _vm.cashpayment[_vm.getCurrentLocale]
                              : null
                          ) +
                          "\n                    ."
                      ),
                    ])
                  : _vm._e(),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.modulo === "services"
            ? _c("div", { staticClass: "booking-information sdr-box" }, [
                _c("h2", [
                  _vm._v(
                    _vm._s(_vm.pleaseselectconfirmation[_vm.getCurrentLocale]) +
                      " " +
                      _vm._s(
                        _vm.getServicesProcessBookingResults.newSpecialsResponse
                          .invoice.bookingCode
                      ) +
                      ", " +
                      _vm._s(
                        _vm.pleaseselectconfirmation2[_vm.getCurrentLocale]
                      ) +
                      " " +
                      _vm._s(
                        _vm.getServicesProcessBookingResults.newSpecialsResponse
                          .invoice.idInvoice
                      )
                  ),
                ]),
                _vm._v(" "),
                _c("hr"),
                _vm._v(" "),
                _c("div", { staticClass: "booking-confirmation clearfix" }, [
                  _c("i", { staticClass: "soap-icon-recommend icon circle" }),
                  _vm._v(" "),
                  _c("div", { staticClass: "message" }, [
                    _c("h4", { staticClass: "main-message" }, [
                      _vm._v(_vm._s(_vm.thankyou[_vm.getCurrentLocale])),
                    ]),
                    _vm._v(" "),
                    _c("p", [
                      _vm._v(_vm._s(_vm.emailhassent[_vm.getCurrentLocale])),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c("hr"),
                _vm._v(" "),
                _c("h2", [
                  _vm._v(_vm._s(_vm.payment[_vm.getCurrentLocale]) + ":"),
                ]),
                _vm._v(" "),
                _c("dl", { staticClass: "term-description" }, [
                  _c("dt", [
                    _vm._v(
                      _vm._s(_vm.payment_firstname[_vm.getCurrentLocale]) + ":"
                    ),
                  ]),
                  _c("dd", [
                    _vm._v(
                      _vm._s(
                        _vm.getServicesProcessBookingObject.customer.firstName
                      )
                    ),
                  ]),
                  _vm._v(" "),
                  _c("dt", [
                    _vm._v(
                      _vm._s(_vm.payment_lastname[_vm.getCurrentLocale]) + ":"
                    ),
                  ]),
                  _c("dd", [
                    _vm._v(
                      _vm._s(
                        _vm.getServicesProcessBookingObject.customer.lastName
                      )
                    ),
                  ]),
                  _vm._v(" "),
                  _c("dt", [
                    _vm._v(
                      _vm._s(_vm.payment_email[_vm.getCurrentLocale]) + ":"
                    ),
                  ]),
                  _c("dd", [
                    _vm._v(
                      _vm._s(_vm.getServicesProcessBookingObject.customer.email)
                    ),
                  ]),
                  _vm._v(" "),
                  _c("dt", [
                    _vm._v(
                      _vm._s(_vm.payment_phone[_vm.getCurrentLocale]) + ":"
                    ),
                  ]),
                  _c("dd", [
                    _vm._v(
                      _vm._s(_vm.getServicesProcessBookingObject.customer.phone)
                    ),
                  ]),
                  _vm._v(" "),
                  _c("dt", [
                    _vm._v(
                      _vm._s(_vm.payment_address[_vm.getCurrentLocale]) + ":"
                    ),
                  ]),
                  _c("dd", [
                    _vm._v(
                      _vm._s(
                        _vm.getServicesProcessBookingObject.customer.address
                      )
                    ),
                  ]),
                  _vm._v(" "),
                  _c("dt", [
                    _vm._v(
                      _vm._s(_vm.payment_zipcode[_vm.getCurrentLocale]) + ":"
                    ),
                  ]),
                  _c("dd", [
                    _vm._v(
                      _vm._s(
                        _vm.getServicesProcessBookingObject.customer.zipCode
                      )
                    ),
                  ]),
                  _vm._v(" "),
                  _c("dt", [
                    _vm._v(
                      _vm._s(_vm.payment_city[_vm.getCurrentLocale]) + ":"
                    ),
                  ]),
                  _c("dd", [
                    _vm._v(
                      _vm._s(_vm.getServicesProcessBookingObject.customer.city)
                    ),
                  ]),
                  _vm._v(" "),
                  _c("dt", [
                    _vm._v(
                      _vm._s(_vm.payment_countrycode[_vm.getCurrentLocale]) +
                        ":"
                    ),
                  ]),
                  _c("dd", [
                    _vm._v(
                      _vm._s(
                        _vm.getServicesProcessBookingObject.customer.countryCode
                      )
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("hr"),
                _vm._v(" "),
                _c("h2", [
                  _vm._v(_vm._s(_vm.paymentmethod[_vm.getCurrentLocale]) + ":"),
                ]),
                _vm._v(" "),
                _c("p", [
                  _vm._v(_vm._s(_vm.forsecurity[_vm.getCurrentLocale])),
                ]),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _vm.getServicesProcessBookingObject.payment.type !== "OO"
                  ? _c("p", { staticClass: "red-color" }, [
                      _vm._v(
                        "\n                        " +
                          _vm._s(_vm.paymentismadeby[_vm.getCurrentLocale]) +
                          "\n                        " +
                          _vm._s(
                            _vm.getServicesProcessBookingObject.payment
                              .ccPayment !== undefined
                              ? _vm.creditcard[_vm.getCurrentLocale]
                              : null
                          ) +
                          "\n                        " +
                          _vm._s(
                            _vm.getServicesProcessBookingObject.payment
                              .ddPayment !== undefined
                              ? _vm.debit[_vm.getCurrentLocale]
                              : null
                          ) +
                          "\n                        " +
                          _vm._s(
                            _vm.getServicesProcessBookingObject.payment.type ===
                              "CS"
                              ? _vm.cashpayment[_vm.getCurrentLocale]
                              : null
                          ) +
                          "\n                    ."
                      ),
                    ])
                  : _vm._e(),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.modulo === "rebooking"
            ? _c("div", { staticClass: "booking-information sdr-box" }, [
                _c("h2", [
                  _vm._v(
                    _vm._s(_vm.pleaseselectconfirmation[_vm.getCurrentLocale]) +
                      " " +
                      _vm._s(
                        _vm.get_RebookingProcessRebookingResults.bookingCode
                      ) +
                      ", " +
                      _vm._s(
                        _vm.pleaseselectconfirmation2[_vm.getCurrentLocale]
                      ) +
                      " " +
                      _vm._s(_vm.get_RebookingProcessRebookingResults.idInvoice)
                  ),
                ]),
                _vm._v(" "),
                _c("hr"),
                _vm._v(" "),
                _c("div", { staticClass: "booking-confirmation clearfix" }, [
                  _c("i", { staticClass: "soap-icon-recommend icon circle" }),
                  _vm._v(" "),
                  _c("div", { staticClass: "message" }, [
                    _c("h4", { staticClass: "main-message" }, [
                      _vm._v(_vm._s(_vm.thankyou[_vm.getCurrentLocale])),
                    ]),
                    _vm._v(" "),
                    _c("p", [
                      _vm._v(_vm._s(_vm.emailhassent[_vm.getCurrentLocale])),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c("hr"),
                _vm._v(" "),
                _c("h2", [
                  _vm._v(_vm._s(_vm.payment[_vm.getCurrentLocale]) + ":"),
                ]),
                _vm._v(" "),
                _c("dl", { staticClass: "term-description" }, [
                  _c("dt", [
                    _vm._v(
                      _vm._s(_vm.payment_firstname[_vm.getCurrentLocale]) + ":"
                    ),
                  ]),
                  _c("dd", [
                    _vm._v(
                      _vm._s(
                        _vm.get_RebookingUsersSearchDataGetProcessRebooking
                          .customer.firstName
                      )
                    ),
                  ]),
                  _vm._v(" "),
                  _c("dt", [
                    _vm._v(
                      _vm._s(_vm.payment_lastname[_vm.getCurrentLocale]) + ":"
                    ),
                  ]),
                  _c("dd", [
                    _vm._v(
                      _vm._s(
                        _vm.get_RebookingUsersSearchDataGetProcessRebooking
                          .customer.lastName
                      )
                    ),
                  ]),
                  _vm._v(" "),
                  _c("dt", [
                    _vm._v(
                      _vm._s(_vm.payment_email[_vm.getCurrentLocale]) + ":"
                    ),
                  ]),
                  _c("dd", [
                    _vm._v(
                      _vm._s(
                        _vm.get_RebookingUsersSearchDataGetProcessRebooking
                          .customer.email
                      )
                    ),
                  ]),
                  _vm._v(" "),
                  _c("dt", [
                    _vm._v(
                      _vm._s(_vm.payment_phone[_vm.getCurrentLocale]) + ":"
                    ),
                  ]),
                  _c("dd", [
                    _vm._v(
                      _vm._s(
                        _vm.get_RebookingUsersSearchDataGetProcessRebooking
                          .customer.phone
                      )
                    ),
                  ]),
                  _vm._v(" "),
                  _c("dt", [
                    _vm._v(
                      _vm._s(_vm.payment_address[_vm.getCurrentLocale]) + ":"
                    ),
                  ]),
                  _c("dd", [
                    _vm._v(
                      _vm._s(
                        _vm.get_RebookingUsersSearchDataGetProcessRebooking
                          .customer.address
                      )
                    ),
                  ]),
                  _vm._v(" "),
                  _c("dt", [
                    _vm._v(
                      _vm._s(_vm.payment_zipcode[_vm.getCurrentLocale]) + ":"
                    ),
                  ]),
                  _c("dd", [
                    _vm._v(
                      _vm._s(
                        _vm.get_RebookingUsersSearchDataGetProcessRebooking
                          .customer.zipCode
                      )
                    ),
                  ]),
                  _vm._v(" "),
                  _c("dt", [
                    _vm._v(
                      _vm._s(_vm.payment_city[_vm.getCurrentLocale]) + ":"
                    ),
                  ]),
                  _c("dd", [
                    _vm._v(
                      _vm._s(
                        _vm.get_RebookingUsersSearchDataGetProcessRebooking
                          .customer.city
                      )
                    ),
                  ]),
                  _vm._v(" "),
                  _c("dt", [
                    _vm._v(
                      _vm._s(_vm.payment_countrycode[_vm.getCurrentLocale]) +
                        ":"
                    ),
                  ]),
                  _c("dd", [
                    _vm._v(
                      _vm._s(
                        _vm.get_RebookingUsersSearchDataGetProcessRebooking
                          .customer.countryCode
                      )
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("hr"),
                _vm._v(" "),
                _c("h2", [
                  _vm._v(_vm._s(_vm.paymentmethod[_vm.getCurrentLocale]) + ":"),
                ]),
                _vm._v(" "),
                _c("p", [
                  _vm._v(_vm._s(_vm.forsecurity[_vm.getCurrentLocale])),
                ]),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _vm.getBookingProcessBookingObject.payment.type !== "OO"
                  ? _c("p", { staticClass: "red-color" }, [
                      _vm._v(
                        "\n                        " +
                          _vm._s(_vm.paymentismadeby[_vm.getCurrentLocale]) +
                          "\n                        " +
                          _vm._s(
                            _vm.get_RebookingUsersSearchDataGetProcessRebooking
                              .payment.ccPayment !== undefined
                              ? _vm.creditcard[_vm.getCurrentLocale]
                              : null
                          ) +
                          "\n                        " +
                          _vm._s(
                            _vm.get_RebookingUsersSearchDataGetProcessRebooking
                              .payment.ddPayment !== undefined
                              ? _vm.debit[_vm.getCurrentLocale]
                              : null
                          ) +
                          "\n                        " +
                          _vm._s(
                            _vm.get_RebookingUsersSearchDataGetProcessRebooking
                              .payment.type === "CS"
                              ? _vm.cashpayment[_vm.getCurrentLocale]
                              : null
                          ) +
                          "\n                    ."
                      ),
                    ])
                  : _vm._e(),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("br"),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "tab-container", attrs: { id: "flight-features" } },
            [
              _c("ul", { staticClass: "tabs" }, [
                _c("li", { staticClass: "active" }, [
                  _c(
                    "a",
                    {
                      attrs: { href: "#flight-details", "data-toggle": "tab" },
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.tab_flightdetails[_vm.getCurrentLocale])
                      ),
                    ]
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "tab-content" }, [
                _c(
                  "div",
                  {
                    staticClass: "tab-pane fade in active",
                    attrs: { id: "flight-details" },
                  },
                  [
                    _vm.get_RebookingUsersSearchDataGetRebookingKey
                      .idTicketOutwards.length > 0
                      ? _c(
                          "div",
                          [
                            _c("h2", [
                              _vm._v(
                                _vm._s(
                                  _vm.tab_header_flightdetailsoutward[
                                    _vm.getCurrentLocale
                                  ]
                                ) + ":"
                              ),
                            ]),
                            _vm._v(" "),
                            _c("sdr-rebooking-bookingno-flightdetails", {
                              attrs: {
                                flight:
                                  _vm.get_RebookingGetRebookingKeyResults
                                    .outwardFlight,
                                flightdirection: "outward",
                                modulo: _vm.modulo,
                                mode: _vm.mode,
                                whichcall: "getrebookingkey",
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.get_RebookingUsersSearchDataGetRebookingKey
                      .idTicketReturn.length > 0
                      ? _c(
                          "div",
                          [
                            _c("br"),
                            _c("hr", {
                              staticStyle: {
                                "border-top": "1px solid #fdb714",
                              },
                            }),
                            _c("br"),
                            _vm._v(" "),
                            _c("h2", [
                              _vm._v(
                                _vm._s(
                                  _vm.tab_header_flightdetailsreturn[
                                    _vm.getCurrentLocale
                                  ]
                                ) + ":"
                              ),
                            ]),
                            _vm._v(" "),
                            _c("sdr-rebooking-bookingno-flightdetails", {
                              attrs: {
                                flight:
                                  _vm.get_RebookingGetRebookingKeyResults
                                    .inboundFlight,
                                flightdirection: "return",
                                modulo: _vm.modulo,
                                mode: _vm.mode,
                                whichcall: "getrebookingkey",
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c("br"),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "btn-large full-width totalbutton",
                        staticStyle: {
                          cursor: "initial",
                          background: "#FDB714",
                        },
                      },
                      [
                        _vm._v(
                          _vm._s(
                            _vm._f("rndAmntRUAFWZ")(
                              _vm.get_RebookingProcessRebookingResultsTotal
                            )
                          )
                        ),
                        _c("br"),
                        _vm._v(" "),
                        _c("span", { staticStyle: { "font-size": "0.5em" } }, [
                          _vm._v(
                            _vm._s(_vm.tincludedtaxes[_vm.getCurrentLocale])
                          ),
                        ]),
                      ]
                    ),
                  ]
                ),
              ]),
            ]
          ),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "sidebar col-sms-6 col-sm-4 col-md-3" },
          [_c("sdr-contact-box")],
          1
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "index" }, [
      _c("i", { staticClass: "soap-icon-arrow-right circle" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }